import moment from 'moment';

export default function getDefaultDate() {
  const format = 'YYYY-MM-DDTHH:mm';

  return moment().startOf('hour').add(1, 'hour')
    .format(format);
}
